/* Bootstrap  */
//import "bootstrap";
import { Modal } from 'bootstrap'

var myModal_minorenni = new Modal(document.getElementById('minorenni'), {
    keyboard: false
  });

  /*var myModal_pwa = new Modal(document.getElementById('popup'), {
    keyboard: false
  });*/

$(window).on('load',function(){
    
    setTimeout(removeLoader, 200);
    function removeLoader(){
        $('.content-wrapper .bottoni').addClass('show')
        $( "#loadingDiv" ).fadeOut(500, function() {
            $( "#loadingDiv" ).remove();
        });  
    }

    myModal_minorenni.hide();
    // if(!localStorage.getItem("popup")) {
    //   localStorage.setItem('popup', true);
    //   $('#popup').modal('show');
    // }
  
    // if(!getCookie('popup')) {
    //   setCookie('popup', true, 10);
    //   $('#popup').modal('show');
    // }
  
});


$('#popup .modal-header').on('click', function () {
    myModal_pwa.hide();
});
$('#minorenni .modal-header').on('click', function () {
    
    myModal_minorenni.hide();
});

$('.home .btn-no').on('click', function () {
    myModal_minorenni.show();
});



function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  

  /*
import lottie from 'lottie-web';

import animationDataVerde from './lottie/nota-doppia-verde.json';
const notaVerdeAnimation = lottie.loadAnimation({
    container: document.getElementById('nota-verde'),
    renderer: 'svg',
    animationData: animationDataVerde
});
notaVerdeAnimation.goToAndPlay(0, true);


import animationDataViola from './lottie/nota-doppia-viola.json';
const notaViolaAnimation = lottie.loadAnimation({
    container: document.getElementById('nota-viola'),
    renderer: 'svg',
    animationData: animationDataViola
});
notaViolaAnimation.goToAndPlay(0, true);

import animationDataAzzurra from './lottie/nota-singola-azzurra.json';
const notaAzzurraAnimation = lottie.loadAnimation({
    container: document.getElementById('nota-azzurra'),
    renderer: 'svg',
    animationData: animationDataAzzurra
});
notaAzzurraAnimation.goToAndPlay(0, true);

import animationDataLilla from './lottie/nota-singola-rosa.json';
const notaLillaAnimation = lottie.loadAnimation({
    container: document.getElementById('nota-lilla'),
    renderer: 'svg',
    animationData: animationDataLilla
});
notaLillaAnimation.goToAndPlay(0, true);
*/

/* Custom SCSS */
import "./index.scss";

/* SwiperJS */
import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';
//import 'swiper/css/navigation';
//import 'swiper/css/pagination';
//import 'swiper/css/scrollbar';
Swiper.use([Navigation, Pagination]);
// init Swiper:
/*
const swiper = new Swiper('.swiper', {  direction: 'vertical',
    loop: true,

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
    },
    modules: [Navigation, Pagination, Scrollbar],
    ...
});
*/

/* Fancybox */
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

/* Gsap */
import { gsap } from "gsap";
//import { ScrollTrigger } from "gsap/ScrollTrigger.js";
//gsap.registerPlugin(ScrollTrigger);

//var Isotope = require('isotope-layout');


function initSwiperStyles() {
    const slider_styles = new Swiper('.slider_styles', {
        slidesPerView: 'auto',
        spaceBetween: 25,
        loop: false
    });
}

function slugify(str) {
    return String(str)
      .normalize('NFKD') // split accented characters into their base characters and diacritical marks
      .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
      .trim() // trim leading or trailing whitespace
      .toLowerCase() // convert to lowercase
      .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
      .replace(/\s+/g, '-') // replace spaces with hyphens
      .replace(/-+/g, '-'); // remove consecutive hyphens
}

jQuery(document).ready( function($) { 

    /*if($('video.img_sfondo').length) {
        $('.audio_icon').fadeIn()
    }*/
    if( $('.audio_icon').length && $('video.img_sfondo').length ) {
        $('.audio_icon').click(function() {
            var video = $('video.img_sfondo').get(0);
            video.muted = !video.muted;
            $(this).toggleClass('unmuted')
        })
    }
    if( $('.audio_icon').length && $('audio.audio_sfondo').length ) {
        $('.audio_icon').click(function() {
            var audio = $('audio.audio_sfondo').get(0);
            if($(this).hasClass('unmuted'))
                audio.pause();
            else
                audio.play();

            $(this).toggleClass('unmuted')
        })
    }

    if( $('body').hasClass('home') && $('#video_intro').length>0 ) {
        // Attivazione video intro in home
        $('.btn-si').click(function() {
            $('#video_intro').addClass('visible')
            var video_intro = $('#video_intro video').get(0);

            const startDelay = $(this).data('start-delay')
            video_intro.currentTime = startDelay;
            video_intro.play();
            var video = $('video.img_sfondo').get(0);
            video.muted = true
            video_intro.onended = function(elem) {
                var href = $('.btn-si').data('href')
                window.location.href = href
            }
        })
    }


    $('.icona_back').click(function() {
        history.back()
    })

	$( ".btn-outline-neon" ).each(function( index ) {
		if( $(this).is(":disabled") || $(this).hasClass('disabled_btn') ){
			$(this).append( '<span class="badge_daisabled">'+ajax_auth_object.coming_soon+'</span>' );
            $(this).attr('href', '#')
            
		}  
	});

    
    const slider_karaoke = new Swiper('.slider_karaoke', {
        slidesPerView: 1.2,
        spaceBetween: 35,
        loop: false,
        breakpoints: {
            768: {
              slidesPerView: 2.2
            },
            990: {
              slidesPerView: 3.2
            }
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    Fancybox.bind('.woocommerce-product-gallery__image a');

    if( $('.page-template-template-karaoke').length) {
        var security = ajax_auth_object.call_nonce;
        $('.slider_karaoke button.single_song').click(function() {
            $('.slider_karaoke button.single_song').removeClass('active')
            $('.start_karaoke').addClass('disabled_btn')
            $(this).addClass('active')
            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: ajax_auth_object.ajaxurl,
                data: {
                    'action': 'load_related_styles',
                    'song_id': $(this).data('id'),
                    'security': security
                },
                beforeSend: function() {
                    $('.css_loader').show();
                    $('.riga_style').addClass('d-none')
                },
                success: function (data) {
  
                    var html = '';
        
                    $.each(data, function(index, item) {
                        html += '<div class="swiper-slide">';
                        html += '<button type="button" class="song_style btn btn-outline-neon btn-outline-neon-cricle '+item.colore+'" data-filtro="'+item.filtro+'">'+item.nome+'</button>';
                        html += '<audio class="audio_sfondo"><source src="'+item.preview_audio+'" type="audio/mp3"></audio>';
                        html += '</div>';
                    });
                    $('.riga_style .swiper-wrapper2').html(html);
                    //initSwiperStyles()
                    $('.css_loader').hide();
                    $('.riga_style').removeClass('d-none')

                }
            });
        })


        $('body').on('click', 'button.start_karaoke', function() {

            if($(this).hasClass('disabled_btn')) return true

            var song_id = $('button.start_karaoke').attr('data-id')
            var stile = $('button.start_karaoke').attr('data-filtro')

            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: ajax_auth_object.ajaxurl,
                data: {
                    'action': 'load_song',
                    'song_id': song_id,
                    'stile': stile,
                    'security': security
                },
                beforeSend: function() {
                    $('.css_loader').show();
                    $('.riga_style').addClass('d-none')
                },
                success: function (data) {
                    $('#song_overlay .testo_titolo_canzone').html(data.post_title.toUpperCase())
                    $('.titolo_canzone .difficolta').addClass(data.difficolta.slug)
                    $('.titolo_canzone .difficolta').html(data.difficolta.name.toUpperCase())
                    $('.titolo_canzone').addClass('style-'+data.difficolta.slug+' '+data.post_name+' '+data.stile)
                    $('.src_mp4').attr('src', data.video_mp4)
                    $('.src_webm').attr('src', data.video_webm)
                    $('#song_overlay').addClass('opened')
                    start_song()

                    var url = window.location.origin+'/'+slugify(data.post_title + ' - ' + stile)
                    _paq.push(['trackEvent', 'Songs', data.post_title, stile]);
                    _paq.push(['setDocumentTitle', data.post_title + ' - ' + stile]);
                    _paq.push(['setCustomUrl', url]);
                    _paq.push(['trackPageView']);
                }
            });
        })

        $('body').on('click', '.slider_styles button.song_style', function() {

            var audioOld = $(this).parents('.swiper-wrapper2').find('.song_style.active').next('.audio_sfondo').get(0);
            if(typeof audioOld !== 'undefined') {
                audioOld.pause();
                audioOld.currentTime = 0;
            }

            $('.song_style').removeClass('active')
            $(this).addClass('active')

            var audioPreview = $(this).next('.audio_sfondo').get(0);
            audioPreview.play();

            var active_song = $('.single_song.active').data('id')
            var active_song_title = $('.single_song.active').data('title')
            var active_style = $('.song_style.active').data('filtro')

            $('.start_karaoke').removeClass('disabled_btn')
            $('.start_karaoke').attr('data-id', active_song)
            $('.start_karaoke').attr('data-filtro', active_style)
            $('.start_karaoke').attr('data-song', active_song_title)

            

        })


        function start_song() {


            var number = Math.floor(Math.random() * 2) + 1;
            if(number==1) {
                var cta_image = 'wow.png'
            } else {
                var cta_image = 'yeah.png'
            }
            $('#cta_image').attr('src', ajax_auth_object.img_dir+cta_image)


            var audioPreview = $('.audio_sfondo').get();
            audioPreview.map((item) => {
                item.pause();
            })

            var btn = $('#song_overlay .start')

            // Entrata cta canzone
            if($('#cta_image').length) {
                var tlCtaOpen = gsap.timeline({ paused:true });
                tlCtaOpen
                    .to('#cta_image', { y:'-50%', opacity: 1, duration: 1.5 } )
                    .to('#cta_image', { scaleX:1.3, scaleY:1.3, duration: .2 })
                    .to('#cta_image', { scaleX:1, scaleY:1, duration: .4 })
            }

            btn.text(btn.data('txtrestart'))

            $('.titolo_canzone').addClass('reduced')
            if(btn.attr('href')=='#') {

                var video = $('video.img_sfondo').get(0)
                
                btn.html($(this).data('txtrestart'))

                video.load()
                video.currentTime = 0;
                video.play()

                var action = false
                video.ontimeupdate = function(elem) {
                    var durata = this.duration
                    if( (durata - 2) < video.currentTime && !action ) {
                        $('#cta_image').addClass('active')
                        console.log('cta')
                        tlCtaOpen.play()
                        action = true;
                    }
                }

                video.onended = function(elem) {
                    $('.bottoni_footer a.start').html($('.bottoni_footer a.start').data('txtgotit').toUpperCase())
                    $('.bottoni_footer a.start').attr('href', ajax_auth_object.realtalent_page)
                    video.currentTime = 0;
                }
                
            } 
        }

        $('body').on('click', '#song_overlay .bottoni_footer a.start', function(e) {
            if($(this).attr('href')=='#') {
                e.preventDefault()
                var video = $('video.img_sfondo').get(0);
                $(this).html($(this).data('txtrestart'))
                video.play()
                video.currentTime = 0;
            }
        }) 


    }
    

    if($('.page-template-template-tutorial').length) {

        const slider_tutorials = new Swiper('.slider_tutorials', {
            slidesPerView: 1,
            loop: false,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                dynamicBullets: true,
            }
        });
        slider_tutorials.on('slideChangeTransitionStart', function () {
            $('.bottoni_footer a.gotit').addClass('disable')
            $('.bottoni_footer').addClass('disappeared')
            $('.video_slide').each(function() {
                $(this).get(0).pause();
            });
        })
        slider_tutorials.on('slideChangeTransitionEnd', function () {
            $('.bottoni_footer').removeClass('disappeared')
        })
    
        $('.page-template-template-tutorial .bottoni_footer a.start').click(function() {
            $(this).next('.gotit').addClass('disable')
            var video = $(this).parents('.swiper-slide').find('.video_slide').get(0);
            $(this).html($(this).data('txtrestart'))
            video.play()
            video.currentTime = 0;
            video.onended = function(elem) {
                $('.bottoni_footer a.start').html($('.bottoni_footer a.start').data('txtstart'))
                $('.bottoni_footer a.gotit').removeClass('disable')
            }
        });
        
    }
    
    $('.modal-header .close').click(function() {
        $('#popup').modal('hide');
    });

    $('body').on('click', '.menu-item .material-symbols-outlined', function() {
        $(this).next('.dropdown-menu').toggleClass('d-none');
    });
    if($(window).width()>990) {

        $('body').on('mouseenter', '.dropdown', function(){ 
            $(this).find('.dropdown-menu').removeClass('d-none');
        });
        $('body').on('mouseleave', '.dropdown', function(){ 
            $(this).find('.dropdown-menu').addClass('d-none');
        });

    }


    $('.link-ev-modal').click(function() {
        $(this).next('.modal').appendTo("#wrapperModalLavora");
        var dest = $(this).data('dest');
        const myModal = new Modal(dest)
        myModal.show();
    });

    $('.navbar-toggler').click(function() {
        $(this).toggleClass('collapsed');
        $('#navbarToggler').toggleClass('aperto');
        $('body').toggleClass('noscroll');
    });

    
    
    /*
    $('.business_model_canvas_grid .row').each(function(index, el) {
        new Isotope( el, {
            itemSelector: '.wp-block-evidenzio-column',
            percentPosition: true,
            masonry: {
              // use outer width of grid-sizer for columnWidth
              columnWidth: '.wp-block-evidenzio-column'
            }
        })    
    });
    */

    /*
    gsap.utils.toArray(".ev_header").forEach((section) => {
        gsap
        .timeline({
          scrollTrigger: {
            trigger: section,
            start: 'top center',
            //markers: true,
          },
        })
        .from(
          $(section).find('.article_thumbnail'),
          { y: 80, 'opacity':0, duration: 1.5, stagger: .5 }
        );
    });
    */

    $('a.scroll-link, .scroll-link>a').click(function(e) {
        e.preventDefault();
        var link = $(this).attr('href');
        $('html, body').animate({ scrollTop: $('#'+link).offset().top-200}, 800);
    });

    

    




    $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
        var header_top = $('.header-top').outerHeight();

        if(scroll > header_top) {
            $('body').addClass('stickyHeader');
        } else {
            $('body').removeClass('stickyHeader');
        }

    });



    /*
    if($('.wpcf7-form').length) {
        $('input[type=text], input[type=email], textarea').each(function(e){
            var ph = $(this).attr('placeholder');
            if($(this).hasClass('wpcf7-validates-as-required')) {
                ph += ' *';
            }
            if( ph ){

                $(this).attr('placeholder', '');
                $(this).parent().append('<label>' + ph + '</label>');
                $(this).parent().append('<span class="focus-border"></span>');

            }
        });
        $('input[type=text], input[type=email], textarea').keyup(function(e){
            var content = $(this).val();
            if(content=='') {
                $(this).removeClass('has-content');
            } else {
                $(this).addClass('has-content');
            }
        });
  
        $('.wpcf7-select').each(function() {
          $(this).parent().prev('label').addClass('placeholder_select');
          $(this).on('change', function() {
              $(this).parent().prev('label').addClass('selected');
          });
        });
  

        $('.upload_wrapper').click(function() {
            $(this).next().find('input[type="file"]').click();
        });
        $('body').on('change', '.wpcf7-file', function(e) {
            var filename = $(this).val().split('\\').pop();
            $('<span>'+filename+'</span>').insertAfter($(this));
        });
        $('.wpcf7-select option:first').html('');

        $('.wpcf7-spinner').appendTo('.wpcf7-form');

    }*/

    if($(window).width()<990) {
        $('footer .titolo-widget-sidebar').click(function() {
            if($(this).find('.toggler').length) $(this).nextAll('div').slideToggle();
        });
        $('footer .toggler').each(function() {
            $(this).parent('.titolo-widget-sidebar').nextAll().hide();
        });
    }

	$('.variations select').each(function() {
		var opz = $(this).val();
		$('a[data-opzione="'+opz+'"]').addClass('selected');
	});

    if($('.wc-block-product-categories').length) {
        $('.wc-block-product-categories > ul > li').each(function(){
            if($(this).find('ul').length) {
                $(this).append('<span class="toggler"></span>');
            }
        });
        $('body').on('click', '.wc-block-product-categories .toggler', function() {
            $(this).prev('ul').toggle();
            $(this).toggleClass('aperto');
        });
        var currentH1 = $('#content h1').text();
        $('.wc-block-product-categories a').each(function(){
            var titolo = $(this).text();
            if(titolo==currentH1) {
                $(this).addClass('active');
                $(this).parents('ul').prevAll('a').addClass('active');
                $(this).parents('ul').show();
                $(this).parents('ul').next('.toggler').addClass('aperto');
            }
        });
    }


        // ricerca ajax
        (function ($) {
            $.fn.delayKeyup = function(callback, ms){
                var timer = 0;
                $(this).keyup(function(){                   
                    clearTimeout (timer);
                    timer = setTimeout(callback, ms);
                });
                return $(this);
            };
        })(jQuery);

        for (let ii = 1; ii < 4; ii++) {
            $('.search_form #search-'+ii).delayKeyup(function(){ 
        
                    var string = $('.search_form #search-'+ii).val();
                    if(string.length>3) {
                        var security = $('.search_form #security').val();
                        $.ajax({
                            type: 'POST',
                            dataType: 'json',
                            url: ajax_auth_object.ajaxurl,
                            data: {
                                'action': 'ajaxsearch',
                                'string': string,
                                'security': security,
                                'lang': ajax_auth_object.languagecode
                            },
                            beforeSend: function() {
                                $('.search_results').html('<div class="lds-ripple"><div></div><div></div></div>');
                            },
                            success: function (data) {
                                var html = '<div class="row">';
    
                                $.each(data, function(index, item) {

                                    html += '<article class="mb-2 mb-lg-3 col-12 col-lg-4 product type-product status-publish has-post-thumbnail">';
                                    html += '<div class="wrapper"><div class="top">'+item.thumb+'</div>';
                                    html += '<div class="bottom p-2"><h3 class="entry-title">'+item.post_title+'</h3><p>'+item.post_excerpt+'</p>';
                                    html += '<a href="'+item.url+'" data-quantity="1" class="button product_type_variable add_to_cart_button">Scegli</a></div></div></article>';
                                
                                });

                                html += '</div>';
                                
                                $('.search_results').html(html);
                            }
                        });
                    }
            }, 500);
        }

});


if($('.scrollToTopBtn').length) {
    var scrollToTopBtn = document.querySelector(".scrollToTopBtn");
    var rootElement = document.documentElement;
    function handleScroll() {
      var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight;
      if (rootElement.scrollTop / scrollTotal > 0.7) {
        scrollToTopBtn.classList.add("showBtn");
      } else {
        scrollToTopBtn.classList.remove("showBtn");
      }
    }
    function scrollToTop() {
      rootElement.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
    scrollToTopBtn.addEventListener("click", scrollToTop);
    document.addEventListener("scroll", handleScroll);
}
